import React, { Fragment } from "react"
import classnames from "classnames"
import Col from "react-bootstrap/Col"
import Form from "react-bootstrap/Form"
import Row from "react-bootstrap/Row"
import { useDisplayIcon } from "../../actions/useDisplayIcon"
import Divider from "../Layout/Divider"
import { RadioButton } from "../Layout/Radiobutton"
import styles from "./LeftSide.module.scss"
import ExpandLess from "@material-ui/icons/ExpandLess"
import ExpandMore from "@material-ui/icons/ExpandMore"
import DoneIcon from "@material-ui/icons/Done"
import { capitalize } from "lodash"

const LeftSide = ({
  search,
  collapses,
  clearFilters,
  onClickItem,
  toggleExpand,
  totalFilters,
  filters,
}) => {
  const display = useDisplayIcon()
  const ExpandMoreResized = (props) => (
    <ExpandMore {...props} style={{ display }} />
  )
  const ExpandLessResized = (props) => (
    <ExpandLess {...props} style={{ display }} />
  )

  function renderRadioButton(item, key) {
    const name = item.name ?? item.type
    const label = name.charAt(0).toUpperCase() + name.slice(1)
    const checked = search[key]?.includes(item.id)

    return (
      <RadioButton
        checked={checked}
        label={label}
        onClick={() => onClickItem(key, item.id)}
      />
    )
  }

  return (
    <div>
      {Object.keys(filters)
        .filter((key) => key != "colors")
        .map((key) => (
          <Fragment key={key}>
            <Row>
              <Col>
                <h5 className="text-black fs-14px">{capitalize(key)}</h5>
              </Col>
              <Col className="text-right">
                {collapses[key] ? (
                  <ExpandMoreResized onClick={() => toggleExpand(key)} />
                ) : (
                  <ExpandLessResized onClick={() => toggleExpand(key)} />
                )}
              </Col>
            </Row>
            {!collapses[key] && (
              <div key="inline-radio" className="mb-3">
                {filters[key].map((item) => (
                  <Fragment key={`${key}-${item.id}`}>
                    {renderRadioButton(item, key)}
                  </Fragment>
                ))}
              </div>
            )}
          </Fragment>
        ))}

      <Divider />
      <Row>
        <Col>
          <h5 className="text-black fs-14px">Dimensions</h5>
        </Col>
        <Col className="text-right">
          {collapses["dimensions"] ? (
            <ExpandMoreResized onClick={() => toggleExpand("dimensions")} />
          ) : (
            <ExpandLessResized onClick={() => toggleExpand("dimensions")} />
          )}
        </Col>
      </Row>
      {!collapses["dimensions"] && (
        <>
          <Form.Label className="text-capitalize text-secondary font-weight-normal">
            <span className="fs-12px">
              Width <span className="color-gray-super-light">(inches)</span>
            </span>
          </Form.Label>
          <Row>
            <Col>
              <Form.Control
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    onClickItem("minWidth", event.target.value)
                  }
                }}
                className={styles["input-dimensions"]}
                type="number"
                placeholder="Min"
                defaultValue={search.minWidth}
              />
            </Col>
            <Col>
              <Form.Control
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    onClickItem("maxWidth", event.target.value)
                  }
                }}
                className={styles["input-dimensions"]}
                type="number"
                placeholder="Max"
                defaultValue={search.maxWidth}
              />
            </Col>
          </Row>
          <Form.Group />
          <Form.Label className="text-capitalize text-secondary font-weight-normal">
            <span className="fs-12px">
              Height <span className="color-gray-super-light">(inches)</span>
            </span>
          </Form.Label>
          <Row>
            <Col>
              <Form.Control
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    onClickItem("minHeight", event.target.value)
                  }
                }}
                className={styles["input-dimensions"]}
                type="number"
                placeholder="Min"
                defaultValue={search.minHeight}
              />
            </Col>
            <Col>
              <Form.Control
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    onClickItem("maxHeight", event.target.value)
                  }
                }}
                className={styles["input-dimensions"]}
                type="number"
                placeholder="Max"
                defaultValue={search.maxHeight}
              />
            </Col>
          </Row>
          <Form.Group />
        </>
      )}

      <Divider />
      <h5>
        <Row>
          <Col>
            <h5 className="text-black fs-14px">Colors</h5>
          </Col>
          <Col className="text-right">
            {collapses["colors"] ? (
              <ExpandMoreResized
                className="cursor-pointer"
                onClick={() => toggleExpand("colors")}
              />
            ) : (
              <ExpandLessResized
                className="cursor-pointer"
                onClick={() => toggleExpand("colors")}
              />
            )}
          </Col>
        </Row>
      </h5>

      {!collapses["colors"] && (
        <div>
          {filters["colors"].map((item) => {
            const isSelected = search.colors.includes(item.id)
            return (
              <span
                key={`color-${item.hexa}`}
                className={classnames(
                  styles["button-color"],
                  "position-relative",
                )}
                style={{
                  backgroundColor: item.hexa,
                }}
                onClick={() => onClickItem("colors", item.id)}>
                {isSelected && (
                  <DoneIcon
                    style={{ color: item.selected, verticalAlign: "inherit" }}
                  />
                )}
              </span>
            )
          })}
        </div>
      )}
      <Divider />
      <button
        type="button"
        className={classnames("btn btn-secondary fs-14px", styles["btn-clear"])}
        onClick={clearFilters}>
        Clear Filters ({totalFilters})
      </button>
    </div>
  )
}

export default LeftSide
